export default __webpack_public_path__ + "img/img_qisthina-5198b518821dd77190c91df80d895383.jpg";